// import Swiper JS
import Swiper, { Autoplay } from 'swiper';

export const hero = () => {

	let heroModules = document.querySelectorAll('.m__hero');
	if(heroModules){
		
		heroModules.forEach((heroModule) => {

			let slideVideos = heroModule.querySelectorAll('video');

			//Trigger the first video on page load
			if(slideVideos.length > 0){
				for (var source in slideVideos[0].children) {
				  var videoSource = slideVideos[0].children[source];
				  if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
				    videoSource.src = videoSource.dataset.src;
				  }
				}
				slideVideos[0].load();
				slideVideos[0].play();
			}

			if(heroModules.length >= 1){
				//Initialise the slider
				const heroSwiper = new Swiper(heroModule.querySelector('.m__hero__swiper'), {
					modules: [Autoplay],
					centeredSlides : true,
					slidesPerView : 'auto',
					loop: true,
					autoplay: {
						delay: 2500,
						disableOnInteraction: false,
					},
					keyboard: {
						enabled: true,
						onlyInViewport: true,
					},
					preloadImages: false,
					lazy: true,
					watchSlidesProgress: true,
				});


				// Force start autoplay
				heroSwiper.autoplay.start();

				// Check again after starting
				setTimeout(() => {
					console.log('Is autoplay running after start:', heroSwiper.autoplay.running);
				}, 100);

			
			
				//Updates when a slide changes
				heroSwiper.on('slideChange', function () {

					//Stop all videos from playing
					slideVideos.forEach((slideVideo) => {
						slideVideo.pause();
						slideVideo.currentTime = 0;
						slideVideo.load();
					})

					//Check for any videos on the slide and make sure they're lazy-loaded (Had a bug with intersection observer not being triggered due to how swiper loads items)
					let slideVideo = heroSwiper.slides[heroSwiper.activeIndex].querySelector("video"); 
					if(slideVideo){
						if(!slideVideo.currentTime > 0){ //Only reload video if it isn't already playing
							for (var source in slideVideo.children) {
							  var videoSource = slideVideo.children[source];
							  if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
							    videoSource.src = videoSource.dataset.src;
							  }
							}
							slideVideo.load();	
							slideVideoTimeout = setTimeout(() => {
								slideVideo.play();
							},1000);
						}
							          
					}

				});

				heroSwiper.on('autoplay', function () {
					console.log('Autoplay running');
				});

			}

		})
		
	}
	
}
